export default {
  name: "PayChargePaid",
  props: {
    ChangeStatus: {
      type: String,
      default: null
    },
    tries: {
      type: Number,
      default: 0
    }
  },
  created() {
    // if (this.ChangeStatus != "") {
    //   this.statusChanged = "";
    // }
    this.statusChanged = "authorized";
  },
  mounted() {
    // this.timeoutVar = setTimeout(this.countUpTimer, 100);
  },
  data() {
    return {
      statusChanged: null,
      triesCount: 0,
      timeoutVar: null,
      countUp: 0,
      checked: false,
      isCountingExtra: false
    };
  },
  watch: {
    ChangeStatus(val) {
      this.statusChanged = val;
      if (this.statusChanged.includes("processing")) {
        this.countUpTimerExtra();
      } else {
        this.checked = true;
      }
    },
    tries(val) {
      this.triesCount = val;
    }
  },
  methods: {
    countUpTimer() {
      if (this.countUp < 100) {
        setTimeout(() => {
          this.countUp += Math.round(10 / 6);
          this.countUpTimer();
        }, 1000);
      } else {
        if (!this.checked) {
          this.checked = true;
          this.checkCharge();
        }
      }
    },
    countUpTimerExtra() {
      this.isCountingExtra = true;
      setTimeout(this.checkCharge, 30 * 1000);
    },
    close(value) {
      clearTimeout(this.timeoutVar);
      if (value === "allowed") this.$emit("closeSuccess", value);
      else this.$emit("closeFailed", value);
    },
    tryAgain() {
      this.statusChanged = null;
      clearTimeout(this.timeoutVar);
      this.$emit("tryAgain");
    },
    checkCharge() {
      this.$emit("checkChargeManually");
    }
  }
};
